import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { PRIVATE_ROUTES, privateRoutes, ROUTES, routes } from "./pages/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Assets/css/style.css";
import "./Assets/css/responsive.css";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import ProtectedRoute from "./components/Protected-Route/ProtectedRoute";
import { updateToken } from "./helpers/api_helper";

function App() {
  const {token, isAuthenticated} = useSelector((state) => state.login);

  useEffect(() => {
    if (token) {
      updateToken(token);
    }
  }, [token]);

  return (
    <Routes>
      <Route path="/" element={<AuthLayout />}>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.component} />
        ))}
      </Route>

      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/dashboard" />} />
        {privateRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<ProtectedRoute route={route} />}
          />
        ))}
      </Route>

      <Route path="*" element={<Navigate to={isAuthenticated ? PRIVATE_ROUTES.DASHBOARD : ROUTES.LOGIN} />} />
    </Routes>
  );
}

export default App;
